import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledPropertyBarContainer = styled.div<{
  isSticky: boolean;
  top: number;
  shouldAnimateTop: boolean;
  shouldAnimateBottom: boolean;
}>`
  @keyframes slideIn {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
  position: ${({ isSticky }) => (isSticky ? 'fixed' : 'relative')};
  top: ${({ isSticky, top }) => (isSticky ? `${top}px` : 'auto')};
  left: ${({ isSticky }) => (isSticky ? '0' : '50%')};
  width: ${({ isSticky }) => (isSticky ? '100%' : '100vw')};
  right: ${({ isSticky }) => (isSticky ? 'auto' : 'unset')};
  margin-left: ${({ isSticky }) => (isSticky ? '0' : '-50vw')};
  margin-right: ${({ isSticky }) => (isSticky ? '0' : 'unset')};
  z-index: 49;
  background-color: white;
  padding: ${toRem(16)} 0;

  ${({ isSticky }) => (isSticky ? 'animation: slideIn 0.6s ease forwards;' : 'transition: top 0.6s ease;')}

  @media (max-width: 767px) {
    top: ${({ isSticky, top }) => (isSticky ? `${top}px` : 'auto')};
  }
`;

export const StyledPropertyBarPlaceholder = styled.div<{ height?: number }>`
  height: ${({ height }) => (height ? `${height}px` : toRem(56))};
`;

export const FlexAnchor = styled.a`
  display: flex;
  align-items: center;
`;

export const StyledPropertyBar = styled.div`
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: ${toRem(16)};

    @media ${baseVariables.mediaQuery.sm} {
      padding-inline-start: ${toRem(16)};
      padding-inline-end: ${toRem(16)};
    }

    @media ${baseVariables.mediaQuery.md} {
      padding-inline-start: ${toRem(32)};
      padding-inline-end: ${toRem(32)};
    }

    @media ${baseVariables.mediaQuery.lg} {
      padding-inline-start: ${toRem(16)};
      padding-inline-end: ${toRem(16)};
    }

    @media ${baseVariables.mediaQuery.xl} {
      padding-inline-start: 0;
      padding-inline-end: 0;
    }
  }

  .property-info {
    display: flex;
    align-items: center;
    gap: ${toRem(16)};

    a,
    button,
    span {
      &::before {
        line-height: 1;
      }
    }
  }

  .property-info .icon-city::before,
  .property-info .icon-location::before,
  .property-info .icon-phone::before,
  .property-info .icon-star-fill::before,
  .property-info .icon-heart-outline::before,
  .property-info .icon-heart-fill::before {
    color: var(--t-non-interactive-accent-color);
  }

  .property-info .icon-location.icon-height::before {
    display: inline-block;
    width: ${toRem(16)};
    height: ${toRem(16)};
    padding: 0;
  }

  .property-info .icon-height {
    gap: ${toRem(4)};
  }

  .property-info .icon-height > span {
    margin-left: 0;
  }

  .property-info .icon-star-fill {
    gap: ${toRem(8)};
  }

  .property-info .icon-star-fill:hover::before {
    font-size: inherit;
  }

  .property-info .rating-count {
    margin-left: ${toRem(8)};
  }

  .property-info .icon-city::before,
  .property-info .icon-location::before,
  .property-info .icon-phone::before,
  .property-info .icon-star-fill::before,
  .property-info .icon-heart-outline::before {
    width: ${toRem(16)};
    height: ${toRem(16)};
    color: var(--t-non-interactive-accent-color);

    a,
    button,
    span {
      &::before {
        line-height: 1;
      }
    }
  }

  .property-info .icon-location.icon-height::before {
    display: inline-block;
    width: ${toRem(16)};
    height: ${toRem(16)};
    padding: 0;
  }

  .property-info .icon-height {
    gap: ${toRem(4)};
  }

  .property-info .icon-height > span {
    margin-left: 0;
  }

  .property-info .icon-star-fill {
    gap: ${toRem(8)};
  }

  .property-info .rating-count {
    margin-left: ${toRem(8)};
  }

  .transparent-button {
    background-color: transparent;
    cursor: pointer;
    padding-top: 0;
    padding-bottom: 0;
  }

  .pointer-cursor {
    cursor: pointer;
  }

  @media ${baseVariables.mediaQuery.md} {
    .property-info {
      gap: ${toRem(24)};
    }
  }

  @media ${baseVariables.mediaQuery.lg} {
    .wrapper {
      flex-direction: row;
      justify-content: space-between;
      gap: ${toRem(24)};

      .property-info {
        flex-shrink: 0;
        margin-left: auto;
      }
    }
  }
`;
